export default "https://assets.egbcdn.net/assets/packs/_/sounds/bet_result-d79666d9f4ae3c5289b242e020309490.mp3";